<template>
    <div v-if="maxPage > 0" class="flex">
        <button
            type="button"
            :disabled="page === 1"
            class="btn btn-ghost btn-square"
            :aria-label="t('product.detail.reviews.pagination.firstPage')"
            @click="selectPage(1)"
        >
            <MiscIcon name="chevrons-left" />
        </button>

        <button
            type="button"
            :disabled="page - 1 < 1"
            class="btn btn-ghost btn-square"
            :aria-label="t('product.detail.reviews.pagination.prevPage')"
            @click="selectPage(page - 1)"
        >
            <MiscIcon name="chevron-left" />
        </button>

        <div class="flex items-center pb-px">
            <span class="font-semibold text-sm text-center px-1">
                {{ t('product.detail.reviews.pagination.pageOf', { page: page, max: maxPage }) }}
            </span>
        </div>

        <button
            type="button"
            class="btn btn-ghost btn-square"
            :disabled="page + 1 > maxPage"
            :aria-label="t('product.detail.reviews.pagination.nextPage')"
            @click="selectPage(page + 1)"
        >
            <MiscIcon name="chevron-right" />
        </button>

        <button
            type="button"
            :disabled="page + 1 > maxPage"
            class="btn btn-ghost btn-square"
            :aria-label="t('product.detail.reviews.pagination.lastPage')"
            @click="selectPage(maxPage)"
        >
            <MiscIcon name="chevrons-right" />
        </button>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    limit: number,
    page: number,
    total: number
}>()

const emits = defineEmits(['selectPage'])

const{ t } = useI18n()

const maxPage = computed(() => {
    return Math.ceil(props.total / props.limit)
})

function selectPage (page: number): void {
    emits('selectPage', page)
}
</script>
